import { render, staticRenderFns } from "./BoxArranger.vue?vue&type=template&id=6e255be0&"
import script from "./BoxArranger.vue?vue&type=script&lang=js&"
export * from "./BoxArranger.vue?vue&type=script&lang=js&"
import style0 from "./BoxArranger.vue?vue&type=style&index=0&id=6e255be0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JrDesignerSectionBox: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/SectionBox.vue').default,JrDesignerHoverBox: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/HoverBox.vue').default,JrDesignerActiveBox: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/ActiveBox.vue').default})
